import { pushDataLayer } from '../lib/dataLayer'

// The redesign form only mounts for this experiment's `redesign` arm.
export const TRIAL_REDESIGN_EXPERIMENT = 'trial_redesign_v1'

// `experiment`/`variant` mirror the keys the GTM adapter already publishes for
// `experiment_view`/`experiment_conversion`, so GA4 reads them the same way.
export const STEP_VIEW_EVENT = 'experiment_step_view'
export const STEP_ADVANCE_EVENT = 'experiment_step_advance'

export interface IStepContext {
  experiment: string
  variant: string
}

// `step` is 1-based to match the human-facing accordion markers (Step 1/2/3).
export function trackStepView(context: IStepContext, step: number, stepId: string): void {
  pushDataLayer({
    event: STEP_VIEW_EVENT,
    experiment: context.experiment,
    variant: context.variant,
    step,
    step_id: stepId,
  })
}

export function trackStepAdvance(context: IStepContext, fromStep: number, toStep: number): void {
  pushDataLayer({
    event: STEP_ADVANCE_EVENT,
    experiment: context.experiment,
    variant: context.variant,
    from_step: fromStep,
    to_step: toStep,
  })
}
